import { useState } from 'react';

import { AssetDTO, FormDTO, FormElement, FormSubmissionRevisionDTO } from '@gearbelt/global';

import { FormSubmissionRevisionDiffView } from './form-submission-revision-diff-view';
import { RevisionHistoryPanel } from './revision-history-panel';

type RevisionHistoryProps = {
  revisions: FormSubmissionRevisionDTO[];
  isLoading?: boolean;
  elements: FormElement[];
  form: FormDTO;
  asset: AssetDTO;
};

export function RevisionHistory({ revisions, isLoading = false, elements, form, asset }: RevisionHistoryProps) {
  const [selectedRevision, setSelectedRevision] = useState<number | undefined>(undefined);

  const current = selectedRevision === undefined ? undefined : revisions.find((revision) => revision.revision === selectedRevision);
  const previous = current ? revisions.find((revision) => revision.revision === current.revision - 1) : undefined;

  return (
    <>
      <RevisionHistoryPanel revisions={revisions} selectedRevision={selectedRevision} onSelectRevision={setSelectedRevision} isLoading={isLoading} />
      {current && previous && (
        <FormSubmissionRevisionDiffView
          open
          onClose={() => setSelectedRevision(undefined)}
          previous={previous}
          current={current}
          elements={elements}
          form={form}
          asset={asset}
        />
      )}
    </>
  );
}
